<template>
  <v-img style="height:100%;"
  :src="handy.loadImg('img/others/' + ($vuetify.breakpoint.smAndUp ? 'sv_hero.png' : 'sv_hero_sm.png'))"
  >
  <v-container
  grid-list-md
  fluid
  fill-height
  >
  <v-row align="center" justify="center">
    <v-col cols="12" sm="5" md="3" mx-auto>
      <div class="text-center">
        <img height="100" width="250" src="@/assets/img/logo/integra_logo.png">
      </div>
      <v-form ref="lForm" @submit.prevent="loginToApp">
        <v-card flat class="transparent">
          <v-card-title>Login</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model.trim="orgCode"
                label="Organization code"
                outlined
                :rules="[rules.required]"
                hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model.trim="userName"
                label="User name"
                outlined
                :rules="[rules.required]"
                hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model.trim="userPwd"
                label="Password"
                outlined
                type="password"
                :rules="[rules.required]"
                hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn text>Forgot password?</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="accent" type="submit" :disabled="loging">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-row>

  <!-- snack bar for error reporting -->
  <v-snackbar :color="sbarCol" v-model="sbar" :timeout="3000" multi-line>
    <span class="mx-auto">{{ sbarMsg }}</span>
  </v-snackbar>
</v-container>
</v-img>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import { login } from '@/utils/auth'

export default {
  data: () => ({
    sbar: false,
    sbarCol: 'error',
    sbarMsg: '',
    config: config,
    handy: handy,
    rules: handy.rules,
    orgCode: '',
    loging: false,
    userName: '',
    userPwd: ''
  }),
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loginToApp () {
      if (this.$refs.lForm.validate()) {
        // validate credentials
        this.loging = true
        this.axios.post(config.API_URL + '/login/verify', {sm_vendor_org_code: this.orgCode, user_name: this.userName, user_pwd: this.userPwd})
        .then(response => {
          // log in
          login(response.data)
          // re-route to home page
          this.$router.go('/')
          this.loging = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.loging = false
        })
      }
    }
  }
}
</script>
